if (!customElements.get("cart-note")) {
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.disclosure = this.closest("details");
      if (this.disclosure && this.disclosure.matches(".cart-note-disclosure")) {
        this.cartNoteToggle = this.disclosure.querySelector(".js-show-note");
        this.summary = this.disclosure.querySelector("summary");
        this.popup = this.disclosure.querySelector(".cart-drawer-popup__content");
        this.textarea = this.disclosure.querySelector("#cart-note");
        this.closeButtons = this.disclosure.querySelectorAll(".js-close");

        this.lastFocused = null;
      }

      this.fetchRequestOpts = {
        method: "POST",
        headers: { Accept: "application/json", "Content-Type": "application/json" },
      };

      this.init();
    }

    init() {
      // existing: save note debounce
      this.debouncedHandleNoteChange = debounce(this.handleNoteChange.bind(this), 300);
      this.addEventListener("input", this.debouncedHandleNoteChange);

      // NEW: focus + close behavior
      if (!this.disclosure) return;

      // when details opens/closes
      this.disclosure.addEventListener("toggle", () => {
        if (this.disclosure.open) {
          this.lastFocused = document.activeElement;

          // focus inside dialog
          setTimeout(() => {
            (this.textarea || this.popup)?.focus?.();
          }, 0);
        }
      });

      
      if (this.closeButtons?.length) {
        this.closeButtons.forEach((btn) => {
          btn.addEventListener("click", () => this.closeNote());
        });
      }

      
      this.disclosure.addEventListener("keydown", (e) => {
        if (!this.disclosure.open) return;

        if (e.key === "Escape") {
          e.preventDefault();
          this.closeNote();
          return;
        }

        if (e.key === "Tab") {
          this.trapFocus(e);
        }
      });
    }

    closeNote() {
      if (!this.disclosure) return;

      
      this.disclosure.open = false;

      // restore focus to trigger (opener)
      setTimeout(() => {
        (this.cartNoteToggle || this.summary || this.lastFocused)?.focus?.();
      }, 0);
    }

    trapFocus(e) {
      if (!this.popup) return;

      const focusables = this.popup.querySelectorAll(
        'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
      );
      if (!focusables.length) return;

      const first = focusables[0];
      const last = focusables[focusables.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    
    handleNoteChange(evt) {
      if (this.cartNoteToggle) {
        const label = evt.target.value ? theme.strings.editCartNote : theme.strings.addCartNote;
        if (this.cartNoteToggle.textContent !== label) this.cartNoteToggle.textContent = label;
      }

      this.fetchRequestOpts.body = JSON.stringify({ note: evt.target.value });
      fetch(theme.routes.cartUpdate, this.fetchRequestOpts);
    }
  }

  customElements.define("cart-note", CartNote);
}

//# sourceMappingURL=/s/files/1/0929/5911/3490/t/6/assets/cart-note.js.map?v=1741200965
